import React from 'react';
import { Dialog, DialogContent, Box, Typography } from '@mui/material';
import { Button } from 'system/atoms';
import { launchModalsSx } from 'modules/campaign-creation/styles';

export enum LaunchOption {
  Now = 'now',
  Draft = 'draft'
}

type Props = {
  isOpen: boolean;
  onClose: () => void;
  onSelectOption: (option: LaunchOption) => void;
};

export const LaunchCampaignConfirmModal: React.FC<Props> = ({
  isOpen,
  onClose,
  onSelectOption
}) => {
  return (
    <Dialog open={isOpen} onClose={onClose}>
      <DialogContent sx={launchModalsSx.modalContent}>
        <Typography sx={launchModalsSx.modalTitle}>Launch campaign?</Typography>
        <Typography sx={launchModalsSx.modalSubtitle}>
          Your campaign will be live and conversations started with its
          recipients.
        </Typography>
        <Box sx={launchModalsSx.buttonGroup}>
          <Button
            variant="primary"
            sx={launchModalsSx.primaryButton}
            onClick={() => onSelectOption(LaunchOption.Now)}
          >
            Now
          </Button>
          <Button
            variant="tertiary"
            sx={launchModalsSx.textButton}
            onClick={() => onSelectOption(LaunchOption.Draft)}
          >
            Keep as draft
          </Button>
        </Box>
      </DialogContent>
    </Dialog>
  );
};
